import { ref, reactive, provide, getCurrentInstance } from 'vue';

/* 
TODO --- 掛單/內部訂單/訂單管理/交班/日結清帳 ---
!為避免useDialog資料過於龐大不好維護，將掛單/內部訂單/訂單管理/交班/日結等彈窗頁面獨立在此處理
!使用方法與useDialog相同，只需注意return的參數與inject的參數都會加上order

*在orderDialogData建立資料 ---
[dialogName]:{
  dialogTemplate: vue檔名 / 模板
  dialogName: unique name，以方便在dialog template模板中做個別處理
  dialogTitle: 標題名,inject('inner_title')
  submitFunc: 自定義的methods function/需搭配dialog的submit使用
  style: {
    width: 寬度,預設100%
    height: 高度,預設99vh
    dialogRows: 可設定grid-rows(string), 預設為(60px auto 70px)(title-body-footer)
  }
  cusProps: 自定義其他屬性,inject('inner_cusProps'),需解構{ cusProps }
  hideClose: 要不要顯示叉叉關閉(預設false)
}
!以上只有dialogTemplate必填，其他皆選填


*使用dialog ---
1. import dialogTemplate.vue ： component: { dialogTemplate }
!此封裝方法的dialogTemplate.vue必須使用<cus-order-dialog></cus-order-dialog>建立內容
2. import { useOrderDialog }
3. 在setup()執行useOrderDialog() 
可解構的參數有{ 
    orderDialogVisible,
    orderDialogTemplate,
    orderDialogName,
    openOrderDialog,
    closeOrder}
orderDialogVisible: 控制dialog開關的boolean值
orderDialogTemplate: 在template中使用：<component :is="orderDialogTemplate"></component> 控制使用哪個模板
orderDialogName: unique name，可以用此判斷目前是使用哪個dialog
openOrderDialog: function，需帶入自定義的參數(dialogName)
closeOrder: function，可關閉彈窗
!以上orderDialogVisible,openOrderDialog, 必須return，其餘有使用到再return即可


* 使用submitFunc ---
在子元素的dialog.vue的setup() inject('order_submit')
子元素執行submit(val) 等同 父元素執行submitFunc(val)

*/

const orderDialogData = {
  pendingOrder: {
    dialogTemplate: 'PendingOrder',
    dialogName: 'pendingOrder',
    dialogTitle: '掛單',
  },
  incomingOrder: {
    dialogTemplate: 'incomingOrder',
    dialogName: 'incomingOrder',
    dialogTitle: '內部訂單',
  },
  outsideOrder: {
    dialogTemplate: 'OutsideOrder',
    dialogName: 'outsideOrder',
    dialogTitle: '外部平台',
  },
  manageOrder: {
    dialogTemplate: 'ManageOrder',
    dialogName: 'manageOrder',
    dialogTitle: '訂單管理',
  },
  dailyRecord: {
    dialogTemplate: 'Accounting',
    dialogName: 'dailyRecord',
    dialogTitle: '日結報表',
  },
  manageAction: {
    dialogTemplate: 'ManageAction',
    dialogName: 'manageAction',
    dialogTitle: '管理',
    submitFunc: 'handleManageAction',
    style: {
      width: '480px',
      height: 'auto',
    },
  },
  shift: {
    dialogTemplate: 'Shift',
    dialogName: 'shift',
    dialogTitle: '交班清帳',
    style: {
      width: '400px',
      height: '550px',
    },
  },
  squareRecord: {
    dialogTemplate: 'Accounting',
    dialogName: 'squareRecord',
    dialogTitle: '清帳條',
  },
  notification: {
    dialogTemplate: 'Notification',
    dialogName: 'notification',
    dialogTitle: '訊息通知',
  },
  deviceSetting: {
    dialogTemplate: 'DeviceSetting',
    dialogName: 'deviceSetting',
    dialogTitle: '周邊管理',
  },
};

const useOrderDialog = () => {
  //建立參數
  const orderDialogVisible = ref(false);
  const orderDialogTemplate = ref(null);
  const orderDialogName = ref(null);
  const title = ref(null);
  const funcName = ref(null);
  const hideClose = ref(false);
  let styleData = reactive({});
  let cus = reactive({});
  let chooseVal = reactive({});
  //打開彈窗
  const doOpenOrderDialog = (dialog) => {
    // console.log(dialog);
    orderDialogTemplate.value = dialog.dialogTemplate;
    orderDialogName.value = dialog.dialogName;
    title.value = dialog.dialogTitle;
    funcName.value = dialog.submitFunc;
    hideClose.value = dialog.hideClose;
    styleData.style = dialog.style;
    cus.cusProps = dialog.cusProps;
    orderDialogVisible.value = true;
  };
  const openOrderDialog = (dialogName, cusProps = {}, newDialogData) => {
    closeOrder();
    const data = orderDialogData[dialogName];
    if (data.cusProps) {
      data.cusProps = { ...data.cusProps, ...cusProps };
    } else {
      data.cusProps = cusProps;
    }
    if (newDialogData) {
      if (newDialogData.dialogTitle) data.dialogTitle = newDialogData.dialogTitle;
      if (newDialogData.submitFunc) data.submitFunc = newDialogData.submitFunc;
      if (newDialogData.hideClose) data.hideClose = newDialogData.hideClose;
      if (newDialogData.style) data.style = newDialogData.style;
    }
    doOpenOrderDialog(data);
  };

  //彈窗內執行submit
  const { proxy } = getCurrentInstance();
  const submit = (val) => {
    chooseVal.data = val;
    proxy[funcName.value](chooseVal.data);
  };

  //關閉彈窗
  const closeOrder = () => {
    orderDialogTemplate.value = null;
    orderDialogVisible.value = false;
  };

  //控制關閉鈕
  const controlCloseButton = (status) => {
    hideClose.value = status;
  };

  //提供給子元素參數
  provide('order_dialogVisible', orderDialogVisible);
  provide('order_name', orderDialogName);
  provide('order_close', closeOrder);
  provide('order_submit', submit);
  provide('openOrderDialog', openOrderDialog);
  provide('order_title', title);
  provide('order_hideClose', hideClose);
  provide('order_controlCloseButton', controlCloseButton);
  provide('order_style', styleData);
  provide('order_cusProps', cus);

  return { orderDialogVisible, orderDialogTemplate, orderDialogName, openOrderDialog, closeOrder };
};

export { useOrderDialog };
